// extracted by mini-css-extract-plugin
export var avatar = "_se-3";
export var avatarContainer = "_se-2";
export var avatarSpacer = "_se-5";
export var avatarSpacerContainer = "_se-4";
export var avatarStackContainer = "_se-1";
export var bubble = "_se-0";
export var remainderBubble = "_se-6";